import React from 'react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import Title from 'components/typography/title/index'
import notifyHoc from 'containers/App/Notification/Notify'
import { IconButton } from 'react-toolbox/lib/button'
import T from 'i18n-react'

const InfoButton = notifyHoc(IconButton)

const ReportHeader = (props) => {
    return (
        <div styleName='header'>
            <Title theme={styles}>{props.title}</Title>
            {props.showDownload && 
                  <InfoButton
                  icon='open_in_new'
                  message={T.translate('pages.project.view.notification.nvqual_download_test_files')}
                  onClick={props.onDownloadClick}
                  className={styles.iconHeader}
                />}
        </div>

    )
}

export default CSSModules(styles)(ReportHeader)
